import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { CenterChildren, FlexColumn } from 'styles/layouts';

export const NewProject = styled(FlexColumn)`
  box-shadow: ${themeStyle.varShadowSoft};
  border: 1px solid ${themeStyle.varInkLight};
  border-radius: ${themeStyle.radiusMedium};
  padding: 12px;
  aspect-ratio: 1/1;
`;

export const NewProjectOverlay = styled(CenterChildren)<{ hovered: boolean }>`
  border: 1px dashed ${themeStyle.varInkLightMedium};
  border-radius: ${themeStyle.radiusSmall};
  height: 100%;

  ${({ hovered }) =>
    hovered && `background-color: ${themeStyle.varInkSuperLight};`}
`;
